const PRE_SESSION_AUTH_PATH =
	/(?:^|\/)(?:auth\/(?:login|confirm|validate|resend|secret_code)|recovery\/(?:send|confirm|resend|secret_code))\/?(?:\?|$)/;

function joinRequestUrl(url: string | undefined, baseURL?: string): string {
	if (!url) return baseURL ?? '';
	if (/^https?:\/\//.test(url)) return url;
	if (!baseURL) return url;

	return `${baseURL.replace(/\/$/, '')}/${url.replace(/^\//, '')}`;
}

/** Шаги входа и восстановления шлют временный Bearer. 401 здесь — ошибка шага, не разлогин. */
export function isPreSessionAuthRequest(url: string | undefined, baseURL?: string): boolean {
	return PRE_SESSION_AUTH_PATH.test(joinRequestUrl(url, baseURL));
}
